import angular from 'angular';

import { AngularHelpContactSupport } from './HelpContactSupport';

const MODULE_NAME = 'app.help-guide.help-contact-support';

angular.module(MODULE_NAME, []).component('esHelpContactSupport', AngularHelpContactSupport);

export default MODULE_NAME;
